import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

const InjectMassage = props => {
  const showIds = true;

  return (
    <FormattedMessage {...props}>
      {(txt) => {
        if(props.tag){
          return (
            <span className={props.className} rel={props.rel}>
              {txt}
              {showIds ? <span dangerouslySetInnerHTML={{ __html: `<!--${props.id}-->` }} /> : null}
            </span>
          )
        }
        return (
          <React.Fragment>
            {txt}
            {showIds ? <span dangerouslySetInnerHTML={{ __html: `<!--${props.id}-->` }} /> : null}
          </React.Fragment>
        );
      }}
    </FormattedMessage>
  );
};

export default injectIntl(InjectMassage, {
  withRef: false
});
